import api from '@/apis'
export const fetchTenantCoupons = (params = {}) => api.get(`/coupon/tenant`, { params });
export const fetchWorkerCoupons = (params = {}) => api.get(`/coupon/worker`, { params });